import React, { useEffect, useState } from "react";
import "./Edit_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successAnimation from "../../../../../../../animation/success_lottie/Success_lottie.json";
import Blue_btn from "../../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../../common_components/common_modal/success_modal/Success_modal";
import { useDispatch } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../../../../features/admin/website/contact_us/get_in_touch/Slice";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { IDS } from "../../../../../../../../utils/IDS";

function Edit_offcanvas({
  show,
  showError,
  setShowError,
  setShow,
  setSuccess,
  setErr,
  handleClose,
  setShowRejectModal,
}) {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      address: "",
      name: "",
      call_us: "",
      working_days: "",
      working_hour: "",
    },
  });
  const imageFile = watch("video");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data?.name || "");
      sendData.append("address", data?.address || "");
      sendData.append("call_us", data?.call_us || "");
      sendData.append("working_days", data?.working_days || "");
      sendData.append("working_hour", data?.working_hour || "");

      const res = await dispatch(Update({ id: data.id, data: sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());

        setModalsuccessShow(true); // ✅ SHOW SUCCESS MODAL
        setShow(false); // close offcanvas
        setSuccess(true); // optional parent flag
      } else {
        setShow(false);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalsuccessShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow]);

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      setDefaultValues({
        id: res?.payload?.data?.id,
        name: res?.payload?.data?.name,
        address: res?.payload?.data?.address,
        call_us: res?.payload?.data?.call_us,
        working_days: res?.payload?.data?.working_days,
        working_hour: res?.payload?.data?.working_hour,
      });
    } catch (error) {
      console.error(error);
      setShow(false);
      setErr(true);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(show);
    }
  }, [show]);

  useEffect(() => {
    if (defaultValues?.id) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Address"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("address", {
                        required: "Address is required",
                      })}
                    />
                    {errors?.address && (
                      <Form.Text className="text-danger">
                        {errors?.address?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Call Us</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Call Us"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("call_us", {
                        required: "Call Us is required",
                      })}
                    />
                    {errors?.call_us && (
                      <Form.Text className="text-danger">
                        {errors?.call_us?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Working Days</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Working Days"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("working_days", {
                        required: "Working Days is required",
                      })}
                    />
                    {errors?.working_days && (
                      <Form.Text className="text-danger">
                        {errors?.working_days?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Working Hours</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Working Hours"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("working_hour", {
                        required: "Working Hours is required",
                      })}
                    />
                    {errors?.working_hour && (
                      <Form.Text className="text-danger">
                        {errors?.working_hour?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
